import React, { useState } from 'react';
import Animation from 'emerald-ui/lib/Animation';
import Button from 'emerald-ui/lib/Button';
import Chip from 'emerald-ui/lib/Chip';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Animation, componentName: 'Animation' }], 'Animation'),
  description: (
    <div>
      The Animation component wraps another component to add animation for when it is added to the DOM or removed from
      it. When the component is added, the animation works by itself. To remove it from the DOM, just pass the{' '}
      <pre>unmount</pre> prop as true to the Animation component.
    </div>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { Animation, Button, useState, Chip },
      whiteBackground: true,
      code: `function DefaultAnimation({ effect }) {
  const [unmount, setUnmount] = useState(false);
  const [remove, setRemove] = useState(false);

  function toggleVisibility() {
    setUnmount(!unmount);

    if (!unmount) {
      setTimeout(() => {
        setRemove(true);
      }, 300);
    } else {
      setRemove(false);
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
      {!remove ? (
        <Animation unmount={unmount}>
          <Chip>Hello</Chip>
        </Animation>
      ) : null}
      <Button
        onClick={toggleVisibility}
        color="info"
        style={{ marginTop: '40px' }}
      >Toggle visibility</Button>
    </div>
  );
}`,
    },
  ],
};
